import { InfoBanner } from '@ui';

export const DirectAcquisitionBanner = () => {
  return (
    <InfoBanner iconType="info">
      <p className="text-info-5 text-m-r">
        The ‘Direct Acquisition’ cases are entered into NOP Connect purely for statistics purposes and do not require
        team, route or any approval
      </p>
    </InfoBanner>
  );
};
